export default "__VITE_ASSET__C4fUNd6z__"